import React, { useEffect } from 'react';
import { FlatList, HStack, VStack, Skeleton } from 'native-base';
import { BrandsCard } from './BrandsCard';
import {
    Brand,
    ProductListPageProps,
    useBrandsByRetailerIdQuery,
    useDutchieStore, useTheme,
} from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { useAppNavigate } from '~/pages';

export const BrandsList = () => {

    const {
        radius_sm,
    } = useTheme();

    const { mutate: getBrands, data, isLoading } = useBrandsByRetailerIdQuery();
    const { retailer, menuType, setProductListProps } = useDutchieStore();
    const { navigate, params } = useAppNavigate();

    useEffect(() => {

        if (retailer && menuType && !data && !isLoading) {
            const variables = {
                'retailerId': retailer.id,
                menuType,
            };
            getBrands(variables);
        }
    }, [retailer, menuType, getBrands]);

    return (
        !isLoading ?
            <VStack ml={2}>
                <Caption text={'shop.favorite_brands'} />
                <FlatList
                    py={2}
                    horizontal={true}
                    data={data?.menu?.brands}
                    renderItem={({ item, index } : { item: Brand, index: number }) =>

                        <BrandsCard brand={item} onSelectBrand={() => {

                            const productListProps: ProductListPageProps = {
                                brand: item
                            };
                            setProductListProps(productListProps);
                            navigate(`w/${params.wallet_id}/shop/product_list`);
                        }} key={index} />
                    }
                />
            </VStack>
            :
            <VStack px={2}>
                <Skeleton
                    w={120}
                    h={6}
                    rounded={radius_sm}
                />
                <HStack space={4} my={4} ml={3}>
                    { [...Array(4)].map((_, index) =>

                        <Skeleton
                            key={index}
                            size={'100px'}
                            rounded={'full'}
                        />
                    )}
                </HStack>
            </VStack>
    );
};
